'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOf(['SP', 'Odds'])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBetButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BET_BUTTON_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_BET_BUTTON_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackBetButtonClick;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackBetButtonClick.js
// module id = 2505
// module chunks = 1